import React from 'react';
import PropTypes from 'prop-types';
// import TinyMCE from 'react-tinymce';
// import TinyMCEInput from 'react-tinymce-input';

import './SimplWysiwyg.scss';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

export class SimplWysiwyg extends React.Component {
  constructor(props) {
    super(props);

    let contentBlock = null;
    if (
      typeof props.content !== 'undefined' &&
      props.content !== null &&
      props.content.length
    ) {
      contentBlock = htmlToDraft(props.content);
    }

    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks,
      );
      const editorState = EditorState.createWithContent(contentState);
      this.state = {
        editorState,
      };
    } else {
      this.state = {
        editorState: EditorState.createEmpty(),
      };
    }
  }

  componentWillUnmount() {
    clearTimeout(this.refresh);
  }

  onEditorStateChange = editorState => {
    this.setState({
      editorState,
    });

    if (this.refresh) {
      clearTimeout(this.refresh);
    }
    this.refresh = setTimeout(() => {
      this.update();
    }, 1000);
  };

  update = () => {
    // console.log('updating!');
    const content = draftToHtml(
      convertToRaw(this.state.editorState.getCurrentContent()),
    );
    this.props.onUpdate(content);
  };

  render() {
    const { editorState } = this.state;

    const toolbar = {
      options: ['inline', 'colorPicker', 'list', 'remove', 'history'],
      inline: {
        options: ['bold', 'italic', 'underline', 'strikethrough'],
      },
      list: {
        inDropdown: false,
        options: ['unordered', 'ordered'],
      },
      link: {
        inDropdown: true,
      },
    };

    return (
      <Editor
        editorState={editorState}
        wrapperClassName="demo-wrapper"
        editorClassName="demo-editor"
        onEditorStateChange={this.onEditorStateChange}
        toolbar={toolbar}
      />
    );
  }
}

SimplWysiwyg.propTypes = {
  content: PropTypes.string,
  onUpdate: PropTypes.func.isRequired,
};

SimplWysiwyg.defaultProps = {
  content: '',
};

export default SimplWysiwyg;



// WEBPACK FOOTER //
// ./src/components/SimplWysiwyg/SimplWysiwyg.js